import React, { useState } from 'react';
import api from '../../../utils/api';
import { tField } from '../../../utils/bilingualHelper';

export default function StatsEditor({ content, handleStatChange, addStat, removeStat, handleStyleChange, addStyle, removeStyle }) {
  const [translating, setTranslating] = useState(null);

  const handleTranslate = async (index, type, text) => {
    if (!text?.trim()) return;
    const key = `${type}-${index}`;
    setTranslating(key);
    try {
      const res = await api.post('/translate', { text, from: 'en', to: 'zh-TW' });
      const translated = res.data.translated;
      if (type === 'stat') {
        const s = content.stats[index];
        handleStatChange(index, 'label', { ...s.label, zh: translated });
      } else {
        const s = content.danceStyles[index];
        handleStyleChange(index, 'name', { en: tField(s.name), zh: translated });
      }
    } catch (err) {
      console.error('Translation failed:', err);
    } finally {
      setTranslating(null);
    }
  };

  const btnStyle = (active) => ({
    display: 'flex', alignItems: 'center', gap: 4, padding: '4px 8px', borderRadius: 6,
    border: '1px solid var(--border)', background: active ? 'var(--primary)' : 'var(--surface)',
    color: active ? '#fff' : 'var(--text-muted)', fontSize: 11, cursor: active ? 'not-allowed' : 'pointer',
    whiteSpace: 'nowrap', fontWeight: 500, transition: 'all 0.2s', alignSelf: 'flex-end', marginBottom: 4
  });
  return (
    <div className="dash-card mb-4" style={{ maxWidth: 900 }}>

      {/* STATS BAR */}
      <h3 className="dash-card-title mb-2">Stats Bar</h3>
      <p className="text-sm text-muted mb-4">The 4 numbers shown below the hero section (e.g. 12,000+ Active Dancers).</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
        {content.stats?.map((s, i) => (
          <div key={i} style={{ padding: 14, border: '1px solid var(--border)', borderRadius: 8, background: '#fafafa' }}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end' }}>
              <div style={{ flex: '0 0 140px' }}>
                <label className="form-label-style" style={{ fontSize: 11 }}>Number / Value</label>
                <input type="text" className="form-input-style" value={s.number} placeholder="e.g. 12,000+" onChange={e => handleStatChange(i, 'number', e.target.value)} />
              </div>
              <div style={{ flex: 1 }}>
                <label className="form-label-style" style={{ fontSize: 11 }}>Label (English)</label>
                <input type="text" className="form-input-style" value={s.label?.en || ''} placeholder="e.g. Active Dancers" onChange={e => handleStatChange(i, 'label', { ...s.label, en: e.target.value })} />
              </div>
              
              <button 
                type="button" 
                style={btnStyle(translating === `stat-${i}`)}
                disabled={!!translating}
                onClick={() => handleTranslate(i, 'stat', s.label?.en)}
                title="Auto-translate"
              >
                {translating === `stat-${i}` ? '⏳' : '→ 中文'}
              </button>

              <div style={{ flex: 1 }}>
                <label className="form-label-style" style={{ fontSize: 11 }}>Label (繁體中文)</label>
                <input type="text" className="form-input-style" value={s.label?.zh || ''} placeholder="e.g. 活躍舞者" onChange={e => handleStatChange(i, 'label', { ...s.label, zh: e.target.value })} />
              </div>
              <button type="button" onClick={() => removeStat(i)} style={{ marginBottom: 2, background: 'none', border: 'none', color: '#c0392b', fontSize: 18, cursor: 'pointer' }} title="Remove">✕</button>
            </div>
          </div>
        ))}
      </div>
      <button type="button" className="btn btn-outline" onClick={addStat}>+ Add Stat</button>

      {/* DANCE STYLES TICKER */}
      <h3 className="dash-card-title mb-2" style={{ marginTop: 36 }}>Dance Styles Ticker</h3>
      <p className="text-sm text-muted mb-4">The scrolling marquee of dance styles shown below the hero.</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
        {content.danceStyles?.map((s, i) => (
          <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'center', padding: 12, border: '1px solid var(--border)', borderRadius: 8, background: '#fafafa' }}>
            <div style={{ flex: '0 0 80px' }}>
              <label className="form-label-style" style={{ fontSize: 11 }}>Emoji</label>
              <input type="text" className="form-input-style" value={s.emoji} placeholder="💃" onChange={e => handleStyleChange(i, 'emoji', e.target.value)} />
            </div>
            <div style={{ flex: 1 }}>
              <label className="form-label-style" style={{ fontSize: 11 }}>Style Name (EN)</label>
              <input type="text" className="form-input-style" value={s.name?.en || ''} placeholder="e.g. Ballet" onChange={e => handleStyleChange(i, 'name', { en: e.target.value, zh: s.name?.zh || '' })} />
            </div>
            
            <button 
              type="button" 
              style={{...btnStyle(translating === `style-${i}`), alignSelf: 'center', marginTop: 22}}
              disabled={!!translating}
              onClick={() => handleTranslate(i, 'style', s.name?.en)}
              title="Auto-translate"
            >
              {translating === `style-${i}` ? '⏳' : '→ 中文'}
            </button>

            <div style={{ flex: 1 }}>
              <label className="form-label-style" style={{ fontSize: 11 }}>Style Name (繁體中文)</label>
              <input type="text" className="form-input-style" value={s.name?.zh || ''} placeholder="芭蕾" onChange={e => handleStyleChange(i, 'name', { en: s.name?.en || '', zh: e.target.value })} />
            </div>
            <button type="button" onClick={() => removeStyle(i)} style={{ marginTop: 18, background: 'none', border: 'none', color: '#c0392b', fontSize: 18, cursor: 'pointer' }} title="Remove">✕</button>
          </div>
        ))}
      </div>
      <button type="button" className="btn btn-outline" onClick={addStyle}>+ Add Dance Style</button>
    </div>
  );
}
